import {
  clientAuth,
  postLogout,
  getAccount,
  postRegis,
  forgetPassword,
  resetPassword,
  refreshToken
} from '@/api/auth'
import { loginOlsera, tokenCollection, logoutOlsera } from '@/api/endpoints/catalog/authOlsera'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getLang, setLang } from '@/utils/lang'
import { guardedRoutes } from '@/router/guardedRoutes'
import router from '@/router'

const state = () => ({
  lang: getLang('lang') ? getLang('lang') : 'id',
  token: getToken('user-token') ? getToken('user-token') : null,
  isLoggedin: getToken('user-token'),
  isLoggedinOlsera: getToken('token-olsera'),
  tokenOlsera: getToken('token-olsera') ? getToken('token-olsera') : null,
  dataWebhook: {},
  account: '',
  testBearerToken: localStorage.getItem('ols-docs-test-bearer-token')
})

const mutations = {
  SET_LANG (state, payload) {
    setLang('lang', payload)
    state.lang = payload
  },
  SET_TOKEN (state, payload) {
    setToken('user-token', payload, true)
    state.token = payload
  },
  SET_IS_LOGGEDIN (state, payload) {
    state.isLoggedin = payload
    guardedRoutes.map(route => {
      router.addRoute({ ...route })
    })
  },
  SET_TOKEN_OLSERA (state, payload) {
    setToken('token-olsera', payload, true)
    state.tokenOlsera = payload
  },
  SET_DATA_WEBHOOK (state, payload) {
    state.dataWebhook = payload
  },
  SET_ACCOUNT (state, payload) {
    state.account = payload
  },
  SET_TEST_BEARER_TOKEN (state, payload) {
    localStorage.setItem('ols-docs-test-bearer-token', payload)
    state.testBearerToken = payload
  }
}

const actions = {
  fetchClientToken ({ commit }, data) {
    return new Promise((resolve, reject) => {
      clientAuth(data).then(response => {
        commit('SET_TOKEN', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchNewToken ({ commit }, data) {
    return new Promise((resolve, reject) => {
      refreshToken(data).then(response => {
        commit('SET_TOKEN', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchOlseraToken ({ commit }, data) {
    return new Promise((resolve, reject) => {
      loginOlsera(data).then(response => {
        commit('SET_TOKEN_OLSERA', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchCollectionToken ({ commit }, data) {
    return new Promise((resolve, reject) => {
      tokenCollection(data).then(response => {
        commit('SET_TEST_BEARER_TOKEN', response.data.access_token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchRegister ({ commit }, data) {
    return new Promise((resolve, reject) => {
      postRegis(data).then(response => {
        resolve(response)
      }).catch(error => {
        // console.log(error)
        reject(error)
      })
    })
  },
  fetchForgetPassword ({ commit }, data) {
    return new Promise((resolve, reject) => {
      forgetPassword(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchResetPassword ({ commit }, data) {
    return new Promise((resolve, reject) => {
      resetPassword(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logOut ({ commit }) {
    return new Promise((resolve, reject) => {
      postLogout().then(response => {
        commit('SET_TOKEN', '')
        commit('SET_TEST_BEARER_TOKEN', null)
        removeToken('user-token')
        removeToken('token-olsera')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  disFetchOlseraToken ({ commit }) {
    return new Promise((resolve, reject) => {
      logoutOlsera().then(response => {
        commit('SET_TOKEN_OLSERA', null)
        removeToken('token-olsera')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  toggleLang ({ commit }, lang) {
    commit('SET_LANG', lang)
  },
  dataWebhook ({ commit }, data) {
    if (data) {
      commit('SET_DATA_WEBHOOK', data)
    } else {
      commit('SET_DATA_WEBHOOK', null)
    }
  },
  getAccountInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getAccount(state.token).then(response => {
        commit('SET_ACCOUNT', response.data.data.name)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  lang: state => state.lang,
  token: state => state.token,
  isLoggedin: state => state.token,
  tokenOlsera: state => state.tokenOlsera,
  dataWebhook: state => state.dataWebhook,
  account: state => state.account,
  testBearerToken: state => state.testBearerToken
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
